export default "__VITE_ASSET__cfd8d8d9__"